import React from 'react';

export default function RouteNotFound() {

	return <div className="d-grid-justify-center empty-route">
		<img src="/img/404.png" alt="" className="empty-route__image" />
	</div>;
}
